import { useContext } from "react";
import { additionalServices, services } from "../data/siteContent";
import { AppContext } from "../App";

export default function ServicesContent() {
  const appContext = useContext(AppContext);

  return (
    <section className="ags-section">
      <div className="container">
        <div className="row g-5 mb-5">
          {services.map((service, index) => (
            <div className="col-12" key={service.slug}>
              <div
                className={`ags-service-panel ags-clickable ${
                  index % 2 === 1 ? "ags-service-panel-reverse" : ""
                }`}
                data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
                role="button"
                tabIndex="0"
                onClick={() =>
                  appContext.navTo({ item: "services", subItem: service.slug })
                }
              >
                <div
                  className={`ags-service-panel-visual ags-visual-${service.visual}`}
                  style={{ backgroundImage: `url(${service.image})` }}
                  role="img"
                  aria-label={service.title}
                />
                <div className="ags-service-panel-body">
                  <p className="ags-section-kicker mb-2">Service Focus</p>
                  <h3 className="font-bold mb-3">{service.title}</h3>
                  {/* <p className="text-muted mb-4">{service.description}</p> */}
                  <div className="row g-2 mb-4">
                    {service.features.slice(0, 4).map((feature) => (
                      <div className="col-md-6" key={feature}>
                        <div className="ags-mini-feature">{feature}</div>
                      </div>
                    ))}
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary btn-rounded btn-padded mt-auto"
                    onClick={(event) => {
                      event.stopPropagation();
                      appContext.navTo({
                        item: "services",
                        subItem: service.slug,
                      });
                    }}
                  >
                    Learn More
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="ags-surface-panel" data-aos="fade-up">
          <p className="ags-section-kicker mb-3">Extended Capability List</p>
          <h2 className="section-title mb-5">
            Some other popular services we provide
          </h2>
          <div className="row g-3">
            {additionalServices.map((item, index) => (
              <div
                className="col-md-6 col-xl-4"
                key={item}
                data-aos="fade-up"
                data-aos-delay={index * 30}
              >
                <div className="ags-mini-feature h-100">{item}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}